<template>
  <v-row no-gutters>
    <v-col>
      <div class="d-flex flex-row justity-start align-center">
        <div class="mr-2">
          <slot name="header-back"></slot>
        </div>
        <div class="mr-2">
          <slot name="header-icon"></slot>
        </div>
        <div class="mr-2">
          <slot name="header-title"></slot>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'HeaderBackOffice',
  data() {
    return {};
  },
};
</script>

<style lang="scss">
@import "@/static/css/Variables.scss";
</style>
